import { render, staticRenderFns } from "./DragAndDropUploader.vue?vue&type=template&id=0b965da3&scoped=true"
import script from "./DragAndDropUploader.vue?vue&type=script&lang=js"
export * from "./DragAndDropUploader.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropUploader.vue?vue&type=style&index=0&id=0b965da3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b965da3",
  null
  
)

export default component.exports